import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';

export interface CustomerReferral {
  id: string;
  referrerBorrowerId?: string;
  referrerName?: string;
  prospectName: string;
  prospectEmail: string;
  prospectPhone: string;
  amountRequired: number;
  status: string;
  adminNote?: string;
  createdDate?: string;
}

export async function getReferrals(status?: string) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/referrals`,
    params: status ? { status } : {},
  });
  return response.data || response;
}

export async function updateReferralStatus(id: string, status: string, adminNote?: string) {
  const response = await HttpClient.PUT({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/referrals/${id}/status`,
    data: { status, adminNote },
  });
  return response.data || response;
}
